import Vue from "vue";
import App from "./App.vue";
import axios from "axios"; // Lecture 346
import Multiselect from "vue-multiselect"; // https://vue-multiselect.js.org/

import router from "./router";
import store from "./store/store";
import Router from 'vue-router';
import VTooltip from 'v-tooltip';
import 'leaflet/dist/leaflet.css'
import "./mixins/global-actions";
import "./mixins/data-handling";
import "./mixins/query-handling";
import "./mixins/authen";
import "./mixins/datetime-handling";
import "./mixins/conversion";
import "./mixins/email-handling";
import "./mixins/email-content";
import "./mixins/extract-data";
import "./mixins/actions";
import "./mixins/string-substitution";
import "./mixins/color-handling";
import "./mixins/user-info-handling";
import "./mixins/html-element-handling";
import "./mixins/multi-language-handling";
import "./mixins/job-handling";
import "./mixins/keap-handling";
import "./mixins/array-handling";
import "./mixins/string-handling";
import "./mixins/calculation";
import "./mixins/builder-handling";
import "./mixins/location-handling";
import "./mixins/template-handling";
import "./mixins/device-handling";
import "./mixins/sort-handling";
import "./directives/click-outside";
import "./directives/scroll"
import tryGet from "./utils/try-get";
import "./utils/hotjar";

// import CKEditor from '@ckeditor/ckeditor5-vue'; // https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/vuejs.html
// import VueCkeditor from 'vueckeditor';
 // https://www.npmjs.com/package/vue-youtube-embed
import Toasted from "vue-toasted";

// import Vue from 'vue'
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

import FormGroupRowLayout from "./components/common/FormGroupRowLayout";
import DetailSectionRowLayout from "./components/common/DetailSectionRowLayout";
import BookingSectionWithDialog from "./components/common/bookings/BookingSectionWithDialog";
import InputDialog from "./components/common/InputDialog";
import EditLabelSetting from "./components/common/EditLabelSetting";
import EditButtonSetting from "./components/common/EditButtonSetting";
import VueSignaturePad from 'vue-signature-pad';

import 'vue2-datepicker/index.css';

import { BASE_URL } from "./constants/url-params";

const bugsnagClient = Bugsnag.start({
  apiKey: "cbc3ac7119706b464870c888fd1bacc0",
  plugins: [new BugsnagPluginVue()]
});

Bugsnag.getPlugin("vue").installVueErrorHandler(Vue);

const BugsnagPlugin = {
  install(Vue) {
    Vue.prototype.$bugsnag = bugsnagClient
  }
}

// https://vsupalov.com/avoid-csrf-errors-axios-django/
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

axios.defaults.baseURL = BASE_URL;
Vue.use(VTooltip, {
  defaultPlacement: 'auto'
});
Vue.component("multiselect", Multiselect); // https://vue-multiselect.js.org
Vue.component("FormGroupRowLayout", FormGroupRowLayout);
Vue.component("DetailSectionRowLayout", DetailSectionRowLayout);
Vue.component("InputDialog", InputDialog);
Vue.component('BookingSectionWithDialog', BookingSectionWithDialog);
Vue.component('EditLabelSetting', EditLabelSetting);
Vue.component('EditButtonSetting', EditButtonSetting);
Vue.use(BugsnagPlugin);
Vue.use(VueSignaturePad);

Vue.prototype.tryGet = tryGet;

// Vue.use( CKEditor );
// Vue.use( VueCkeditor );

const toastOption = {
  icon: "check",
  className: "success-toast",
  containerClass: "container-toast",
  duration: 5000,
  type: "success"
};
Vue.use(Toasted, toastOption);

// https://scotch.io/tutorials/how-to-create-filters-in-vuejs-with-examples
Vue.filter("trimSeconds", function (value) {
  // Used for trimming the seconds off an event time (turn 18:00:00 into 18:00)
  return value.slice(0, -3); // https://stackoverflow.com/questions/952924/javascript-chop-slice-trim-off-last-character-in-string
});
// https://stackoverflow.com/questions/44538110/how-to-format-numbers-in-vuejs
// http://numeraljs.com/
var numeral = require("numeral");
Vue.filter("noDecimal", function (value) {
  // Used for making something no decimal (good for credits)
  return numeral(value).format("0");
});

Vue.filter("singleDecimal", function (value) {
  // Used for making something 1 decimal (good for actual distances)
  return numeral(value).format("0.0");
});

Vue.filter("twoDecimals", function (value) {
  // Used for making something 2 decimals (good for length in hours of a job)
  return numeral(value).format("0.00");
});

// Overwrite $router.replace function to ignore error navigation duplicated
const originalPush = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    console.log(err.name);
    console.log(typeof (err));
    if (err.name === "NavigationDuplicated") {
      // resolve err
      return err
    }
    // rethrow error
    return Promise.reject(err)
  })
}

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js